import { z } from "zod";
import { createCustomSettings } from "@rootreeweb/zod-to-elements";
export const dimensionsSchema = z.object({
    width: z.number().describe("Width (mm)"),
    height: z.number().describe("Height (mm)"),
    gusset: z
        .number()
        .optional()
        .describe(createCustomSettings({
        label: "Gusset (mm)",
        dependsOn: {
            field: "requestDetails.pouchType",
            value: ["Stand-Up Pouch", "Quad Seal", "Corner Spout", "Top Spout"],
        },
    })),
    totalWidth: z
        .number()
        .optional()
        .describe(createCustomSettings({
        label: "Total Width (mm)",
        dependsOn: {
            field: "requestDetails.pouchType",
            value: ["Pillow Pouch"],
        },
    })),
    slitWidth: z
        .number()
        .optional()
        .describe(createCustomSettings({
        label: "Slit Width (mm)",
        dependsOn: {
            field: "requestDetails.pouchType",
            value: ["Rollstock"],
        },
    })),
    finishedWidth: z
        .union([
        z.literal("64mm-finished-width").describe("64mm Finished Width"),
        z.literal("76mm-finished-width").describe("76mm Finished Width"),
        z.literal("89mm-finished-width").describe("89mm Finished Width"),
        z.literal("100mm-finished-width").describe("100mm Finished Width"),
        z.literal("127mm-finished-width").describe("127mm Finished Width"),
        z.literal("153mm-finished-width").describe("153mm Finished Width"),
    ])
        .optional()
        .describe(createCustomSettings({
        label: "Finished Width",
        dependsOn: {
            field: "requestDetails.pouchType",
            value: ["Pillow Pouch"],
        },
    })),
});
//# sourceMappingURL=dimensions.js.map